module.exports = __webpack_public_path__ + "static/contact-portrait-2f85ec44d8254fb12b374a091845168e.jpg";